var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "createQuestions" } },
    [
      _vm._m(0),
      [
        _c(
          "form",
          {
            staticClass: "form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onSubmit()
              },
            },
          },
          [
            _c("div", { staticClass: "link-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isExercise,
                    expression: "isExercise",
                  },
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: false,
                  checked: _vm._q(_vm.isExercise, false),
                },
                on: {
                  change: function ($event) {
                    _vm.isExercise = false
                  },
                },
              }),
              _vm._v("קורס "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isExercise,
                    expression: "isExercise",
                  },
                ],
                attrs: { type: "radio" },
                domProps: {
                  value: true,
                  checked: _vm._q(_vm.isExercise, true),
                },
                on: {
                  change: function ($event) {
                    _vm.isExercise = true
                  },
                },
              }),
              _vm._v("תרגולים "),
            ]),
            _vm.isExercise
              ? _c("b-taginput", {
                  staticStyle: { width: "350px" },
                  attrs: {
                    ellipsis: "",
                    icon: "label",
                    placeholder: "הזן מספרי תרגולים (הפרד בפסיק או Enter)",
                    "aria-close-label": "מחק תרגולים",
                    separator: [",", ";", " "],
                    "allow-duplicates": false,
                  },
                  model: {
                    value: _vm.exercises,
                    callback: function ($$v) {
                      _vm.exercises = $$v
                    },
                    expression: "exercises",
                  },
                })
              : _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.course,
                      expression: "course",
                    },
                  ],
                  staticStyle: { width: "350px" },
                  attrs: { type: "text", placeholder: "הזן מספר קורס" },
                  domProps: { value: _vm.course },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.course = $event.target.value
                    },
                  },
                }),
            _c(
              "button",
              {
                staticClass: "button-style",
                attrs: { disabled: _vm.isLoading, type: "submit" },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.isLoading ? "מייצא..." : "ייצא שאלות") + " "
                ),
              ]
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "createQuestions-item" }, [
      _c("h2", { staticStyle: { color: "#286695" } }, [
        _vm._v("יצירת קובץ שאלות"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }